import {SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class RichText {
	static init() {

		GlobalVariables.resizeCallbacks.push(this);

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach((img) => {
			let link = img.closest('a');
			if (link && link.getAttribute('target') !== "_blank") {
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

		document.fonts.ready.then( () =>{
			this.editorTexts = document.querySelectorAll('.text-underline');
			this.editorTexts.forEach((text) => {
				this.splitText(text);
			});
		});

		this.editorBlockquote = document.querySelectorAll('.rich-text blockquote');
		this.editorBlockquote.forEach((blockquote) => {
			const element = document.createElement("span");
			element.innerHTML = `<svg width="56" height="48" viewBox="0 0 56 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 48V35.9752C0 31.9337 0.673401 27.7267 2.0202 23.354C3.43434 18.9151 5.45455 14.6749 8.08081 10.6335C10.7071 6.52588 13.8721 2.98137 17.5758 0L28.1818 7.25466C25.0842 11.6273 22.6936 16.1325 21.0101 20.7702C19.3266 25.3416 18.4848 30.3106 18.4848 35.677V48H0ZM27.8182 48V35.9752C27.8182 31.9337 28.4916 27.7267 29.8384 23.354C31.2525 18.9151 33.2727 14.6749 35.899 10.6335C38.5253 6.52588 41.6902 2.98137 45.3939 0L56 7.25466C52.9024 11.6273 50.5118 16.1325 48.8283 20.7702C47.1448 25.3416 46.303 30.3106 46.303 35.677V48H27.8182Z" fill="#4EA933"/>
</svg>`;
			element.classList.add('svg');
			blockquote.insertBefore(element, blockquote.firstChild);
		});

	}

	static splitText(element){

		element.innerHTML = element.innerHTML.replaceAll('-', '<span>-</span>');
		element.isSplited = new SplitText(element, {
			type: "lines",
			linesClass: "lines",
			tag: "span"
		});

	}

	static splitTextRevert(){
		const items = document.querySelectorAll(".text-underline");
		items.forEach(elem => {
			if( elem.isSplited ){
				elem.isSplited.revert();
			}
			this.splitText(elem);
		});
	}

	static resize() {
		this.splitTextRevert();
	}

}